module.exports = __webpack_public_path__ + "static/media/booking1.16774f09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/booking1.jpg
// module id = 2011
// module chunks = 0